import { useAppStore } from '@/store/app/app'
import { useCityStore } from '@/store/city/city'

export default defineNuxtPlugin(async ({ $cityPrefix, ssrContext }) => {
  const appStore = useAppStore()

  if (import.meta.server) {
    // проверяем запрос, что это webview
    appStore.detectWebview(ssrContext?.event.node.req.headers)
  }

  const { getCityInfo, cityInfo } = useCityStore()

  if (!cityInfo.domain_prefix) {
    await getCityInfo($cityPrefix as string)
  }
})
